const showMoreBlocks = document.querySelectorAll('[data-show-more-block]');

if (showMoreBlocks.length > 0) {
	showMoreBlocks.forEach(block => {
		const showMoreList = block.querySelector('[data-show-more-list]');
		const showMoreBtn = block.querySelector('[data-show-more]');

		showMoreBtn.addEventListener('click', () => {
			if (showMoreBtn.innerText === 'Показать ещё') {
				// Дублирование элементов
				const items = Array.from(showMoreList.children);
				items.forEach(item => {
					const clonedItem = item.cloneNode(true);
					clonedItem.dataset.duplicated = 'true'; // Пометим дубликаты
					showMoreList.appendChild(clonedItem);
				});
				showMoreBtn.innerText = 'Скрыть';
			} else if (showMoreBtn.innerText === 'Скрыть') {
				// Удаление дубликатов
				showMoreList.querySelectorAll('[data-duplicated]').forEach(item => item.remove());
				showMoreBtn.innerText = 'Показать ещё';
			}
		});
	});
}
